import { FileInfoDto } from '@lmt/shared-types';
import React, { FC, useMemo } from 'react';
import styles from '@lmt/unicorn-shared/src/app/components/patients/profile/cases/components/documents/DocumentItem.module.scss';
import {
  getDocumentTitle,
  useFileCallbacks,
} from '../../../patients/profile/cases/components/documents/common';
import { DocumentLoader } from '../../../patients/profile/cases/components/documents/DocumentLoader';
import { DocumentIcon } from '../../../patients/profile/cases/components/documents/DocumentIcon';

interface Props {
  document?: FileInfoDto;
}

export const HL7DocumentItem: FC<Props> = React.memo(
  function HL7DocumentItem(props) {
    const { document } = props;

    if (!document) {
      return null;
    }

    const { isLoading, onClick } = useFileCallbacks(document);

    const title = useMemo(
      () => getDocumentTitle(document.name),
      [document.name],
    );
    return (
      <div className={styles.container} data-test-id="document-item">
        <div title={title} className={styles.titleContainer} onClick={onClick}>
          {isLoading && <DocumentLoader />}
          <DocumentIcon
            data-loading={isLoading}
            fileType={document.type}
            filename={document.name}
            className={styles.icon}
          />
          <div className={styles.title}>{title}</div>
        </div>
      </div>
    );
  },
);
